import {
  useMutation,
  OperationVariables,
  DefaultContext,
  ApolloCache,
  DocumentNode,
  TypedDocumentNode,
  MutationHookOptions,
  MutationTuple,
  InternalRefetchQueryDescriptor,
} from '@apollo/client';

interface ICollectionMutationHookOptions<
  TData = any,
  TVariables = OperationVariables,
  TContext = DefaultContext,
  TCache extends ApolloCache<any> = ApolloCache<any>
> extends Omit<
    MutationHookOptions<TData, TVariables, TContext, TCache>,
    'refetchQueries'
  > {
  refetchQueries?: InternalRefetchQueryDescriptor[];
}

export const useCollectionMutation = <
  TData = any,
  TVariables = OperationVariables,
  TContext = DefaultContext,
  TCache extends ApolloCache<any> = ApolloCache<any>
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: ICollectionMutationHookOptions<TData, TVariables, TContext>
): MutationTuple<TData, TVariables, TContext, TCache> => {
  const mutationTuple = useMutation<TData, TVariables, TContext, TCache>(
    mutation,
    {
      ...options,
      refetchQueries: [...(options?.refetchQueries ?? []), 'collection'],
    }
  );

  return mutationTuple;
};
